import { State } from ".";

export const getWeekVisible = (state: State): string => state.ui.weekVisible;
